import { Image } from "@mantine/core";

import sparkleIconPurple from "../../assets/sparkle-icon-purple.png";
import sparkleIcon from "../../assets/sparkle-icon.png";
import styles from "./Sparkle.module.css";

const ICONS = {
    white: sparkleIcon,
    purple: sparkleIconPurple,
};

interface SparkleProps {
    color?: keyof typeof ICONS;
    size?: number;
}

export const Sparkle = ({ color = "white", size = 16 }: SparkleProps) => (
    <Image
        src={ICONS[color]}
        alt=""
        aria-hidden
        w={size}
        h={size}
        fit="contain"
        className={`${styles.sparkle} ${color === "white" ? styles.sparkleWhite : ""}`}
    />
);
